// automatically generated by the FlatBuffers compiler, do not modify

export enum DoorStatus {
  RearDoorOpenSequence = 0,
  DoorOpenSequence = 1,
  GateLock = 2
}
